import config from '../config/config';

export const getS3Url = (key) => {
    return `${config.mediaBaseUrl}/${key}`;
};

export const loadGalleryImages = async (options = {}) => {
    const {
        folderName = null,
        limit = null,
        randomize = false,
        useThumbnails = false
    } = options;

    try {
        const { apiUrl } = config;
        console.log('Base URL:', apiUrl);

        let url;
        if (folderName) {
            url = `${apiUrl}/api/gallery/folders/${encodeURIComponent(folderName)}`;
        } else {
            url = `${apiUrl}/api/gallery/all-images`;
        }

        console.log('Making request to:', url);

        const response = await fetch(url);
        console.log('Response status:', response.status);

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log('Received full data:', data);

        // Handle both folder contents and main gallery response
        let mediaItems = [];

        if (data.files && Array.isArray(data.files)) {
            console.log('Found files array of length:', data.files.length);
            mediaItems = data.files.map(file => ({
                thumbnailPath: getS3Url(useThumbnails ? file.thumbnailKey : file.originalKey),
                originalPath: getS3Url(file.originalKey),
                type: file.type || (file.originalKey.match(/\.(mp4|webm|mov)$/i) ? 'video' : 'image')
            }));
        } else {
            console.warn('No files array found in response:', data);
        }

        // Additional logging for debugging
        console.log('Folder name:', data.folderName);
        console.log('Uploaded by:', data.uploadedBy);
        console.log('Description:', data.description);
        console.log('Date created:', data.dateCreated);

        if (randomize) {
            mediaItems = mediaItems.sort(() => Math.random() - 0.5);
        }

        if (limit && mediaItems.length > limit) {
            mediaItems = mediaItems.slice(0, limit);
        }

        console.log('Final processed media items:', mediaItems);
        return mediaItems;
    } catch (error) {
        console.error('Error loading gallery images:', error);
        return [];
    }
};